// extracted by mini-css-extract-plugin
export var noSpinners = "_mx-6";
export var percentageInput = "_mx-7";
export var variantColor1 = "_mx-0";
export var variantColor2 = "_mx-1";
export var variantColor3 = "_mx-2";
export var variantColor4 = "_mx-3";
export var variantColor5 = "_mx-4";
export var variantColor6 = "_mx-5";